import type { Reference } from '@ps/web-martech-cms-types';
import type {
  MainNavigationBlock,
  SecondaryNavigationBlock,
  SupportNavigationBlock
} from '@ps/web-martech-cms-types/SiteHeader';
import { Button } from '@ps/web-shared-components';
import classNames from 'clsx';

import BrandIconButton from '../BrandIcon/BrandIconButton';

import SidebarItem from './SidebarItem';
import styles from './SidebarV2.scss';
import Cross from './assets/cross.svg';

interface SidebarV2Props {
  mainNavigation: MainNavigationBlock[];
  secondaryNavigation: SecondaryNavigationBlock[];
  supportNavigation: SupportNavigationBlock[];
  menuOpen: boolean;
  toggleMenu: () => void;
  brandIcon: Reference[];
  brandIconUrl?: string;
}

const SidebarV2: React.FC<SidebarV2Props> = ({
  mainNavigation,
  secondaryNavigation,
  supportNavigation,
  menuOpen,
  toggleMenu,
  brandIcon,
  brandIconUrl
}) => (
  <>
    <nav
      className={classNames(styles.sidebar, {
        [styles.sidebarOpen]: menuOpen
      })}
    >
      <div className={styles.topMenu}>
        <div className={styles.brandLogo}>
          <BrandIconButton
            brandIcon={brandIcon}
            brandIconUrl={brandIconUrl}
            onClick={toggleMenu}
            inMenu
          />
        </div>
        <Button
          variant="tertiary"
          size="default"
          className={styles.closeButton}
          icon={Cross}
          onPress={toggleMenu}
        />
      </div>
      <ul className={styles.mainMenu}>
        {/* This should be changed when moving forward with either web navigation
        redesign prototypes. */}
        {mainNavigation.map(
          (navItem: MainNavigationBlock) =>
            navItem.url &&
            navItem.title && (
              <SidebarItem
                key={navItem.url}
                icon={navItem.icon}
                title={navItem.title}
                url={navItem.url}
                resolverTag={navItem.resolver_tag}
                onClick={toggleMenu}
              />
            )
        )}
        {secondaryNavigation.map(
          (navItem: SecondaryNavigationBlock) =>
            navItem.url &&
            navItem.title && (
              <SidebarItem
                key={navItem.url}
                icon={navItem.icon}
                title={navItem.title}
                url={navItem.url}
                resolverTag={navItem.resolver_tag}
                onClick={toggleMenu}
              />
            )
        )}
        {supportNavigation.map(
          (navItem: SupportNavigationBlock) =>
            navItem.url &&
            navItem.title && (
              <SidebarItem
                key={navItem.url}
                icon={navItem.icon}
                title={navItem.title}
                url={navItem.url}
                resolverTag={navItem.resolver_tag}
                onClick={toggleMenu}
              />
            )
        )}
      </ul>
    </nav>
    <div
      className={classNames(styles.overlay, {
        [styles.overlayOpen]: menuOpen
      })}
      onClick={toggleMenu}
    />
  </>
);

export default SidebarV2;
